"use client";

import styles from "./hero.module.css";

export default function Hero() {
  return (
    <>
      <div
        className={`
          ${styles.container}
          pb-0 relative w-full bg-black overflow-hidden
        `}
      >
        {/* MOBILE: video vertical */}
        <div className="block md:hidden w-full h-[80vh]">
          <video
            className="block w-full h-full object-cover"
            playsInline
            muted
            autoPlay
            loop
            preload="metadata"
            aria-label="Video principal mobile"
          >
            <source
              src="/bebop/video/video_vertical8.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* DESKTOP/TABLET */}
        <div className="hidden md:block w-full h-[100vh] overflow-hidden">
          <video
            className="block w-full h-full object-cover lg:object-contain lg:w-full lg:h-auto"
            playsInline
            muted
            autoPlay
            loop
            preload="metadata"
            aria-label="Video principal desktop"
          >
            <source
              src="/bebop/video/file3.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>

      <div className={`${styles.controlsContainer} relative w-full`}>
        <div className="container container--full-bleed relative" />
      </div>
    </>
  );
}